import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { RecordContextProvider, Title, useGetOne } from "react-admin";
import { navigateToBaseRoute, useRouteId } from "@/utils/route-utility";
import { ProjectShowOverview } from "@/containers/projects/projects/show/ProjectShowOverview";

/**
 * Shown at `/projects/:projectId/#/` — same overview content as the project Show “Overview” tab,
 * without repeating the project id in the hash (parity with Niyaaz Events in-context dashboard).
 */
const ActiveProjectDashboard = () => {
  const id = useRouteId();
  const { data, isPending, error } = useGetOne(
    "projects",
    { id: id ?? "" },
    { enabled: Boolean(id) }
  );

  if (!id) {
    return null;
  }

  if (isPending) {
    return (
      <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !data) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">Could not load this project.</Typography>
      </Box>
    );
  }

  const title = typeof data.name === "string" && data.name.trim() !== "" ? data.name : "Project";

  return (
    <RecordContextProvider value={data}>
      <Title title={title} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
          px: 2,
          pt: 2,
          pb: 1,
        }}
      >
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigateToBaseRoute("projects", null)}
        >
          All projects
        </Button>
      </Box>
      <ProjectShowOverview />
    </RecordContextProvider>
  );
};

export default ActiveProjectDashboard;
